import { GameweekDto, GameweekSchema, GameweeksListResponse, GameweeksListResponseSchema } from '@/types/gameweek';
import { apiRequest } from './client';

const GAMEWEEKS_BASE = '/api/v1/gameweeks';

export interface GetGameweeksParams {
  season_id: string; // required
  is_current?: boolean; // default true
  order?: 'number.asc' | 'number.desc' | 'deadline_time.asc' | 'deadline_time.desc' | 'created_at.asc' | 'created_at.desc';
  limit?: number; // 1-100 default 50
  offset?: number; // default 0
}

export async function getGameweeks(params: GetGameweeksParams): Promise<GameweeksListResponse> {
  const query = new URLSearchParams();
  query.set('season_id', params.season_id);
  if (params.is_current !== undefined) query.set('is_current', String(params.is_current));
  if (params.order) query.set('order', params.order);
  if (params.limit !== undefined) query.set('limit', String(params.limit));
  if (params.offset !== undefined) query.set('offset', String(params.offset));

  const qs = query.toString();
  const url = `${GAMEWEEKS_BASE}${qs ? `?${qs}` : ''}`;

  const res = await apiRequest<unknown>({ url, method: 'GET' });
  return GameweeksListResponseSchema.parse(res);
}

export async function getCurrentGameweek(seasonId: string): Promise<GameweekDto> {
  const url = `${GAMEWEEKS_BASE}/current?season_id=${encodeURIComponent(seasonId)}`;
  const res = await apiRequest<unknown>({ url, method: 'GET' });
  return GameweekSchema.parse(res);
}

